import React, { useState, useEffect } from 'react';
import { IBanner, IAppScreen } from '../MobileAppTypes';
import { BannerController } from './BannerController';
import BannerList from './BannerList';
import BannerForm from './BannerForm';
import Modal from '../../Modal/Modal';

interface IBannerManagerProps {
  appId: string;
  screens: IAppScreen[];
}

const BannerManager: React.FC<IBannerManagerProps> = ({ appId, screens }) => {
  const [banners, setBanners] = useState<IBanner[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingBanner, setEditingBanner] = useState<IBanner | undefined>(undefined);

  useEffect(() => {
    loadBanners();
  }, [appId]);

  const loadBanners = async () => {
    setIsLoading(true);
    try {
      const response = await BannerController.listBanners(appId);
      setBanners(response.Success ? response.Value || [] : []);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNew = () => {
    setEditingBanner(undefined);
    setShowForm(true);
  };

  const handleEdit = (banner: IBanner) => {
    setEditingBanner(banner);
    setShowForm(true);
  };

  const handleSaved = () => {
    setShowForm(false);
    setEditingBanner(undefined);
    loadBanners();
  };

  const handleRemove = async (banner: IBanner) => {
    if (!banner.PublicId) return;
    if (!window.confirm('Are you sure you want to remove this banner?')) return;

    const response = await BannerController.removeBanner(appId, banner.PublicId);
    if (response.Success) {
      loadBanners();
    }
  };

  return (
    <div>
      <BannerList banners={banners} isLoading={isLoading} onRefresh={loadBanners} onNew={handleNew} onEdit={handleEdit} onRemove={handleRemove} />

      {showForm && (
        <Modal setModalOpen={setShowForm} size="l" title={editingBanner ? 'Edit Banner' : 'New Banner'}>
          <BannerForm appId={appId} banner={editingBanner} screens={screens} onSaved={handleSaved} onCancel={() => setShowForm(false)} />
        </Modal>
      )}
    </div>
  );
};

export default BannerManager;
